/* global initialPrice, utforandeBreddValues, heightPrice, breddPrice, variationPrices, updatePrice, calculationType, totalHeightPrice, transomPrice, utforandeData, taxRate */

// Import modules
import { PriceCalculator } from './modules/PriceCalculator.js'
import { FormValidator } from './modules/FormValidator.js'
import { HeightCalculator } from './modules/HeightCalculator.js'
import { UIManager } from './modules/UIManager.js'

document.addEventListener('DOMContentLoaded', function () {
  const productVariable = document.querySelector('.product-type-variable')
  if (!productVariable) {
    return
  }

  if (typeof initialPrice === 'undefined') {
    return
  }

  // Create instances of our modules
  const priceCalculator = new PriceCalculator({
    initialPrice,
    utforandeBreddValues,
    heightPrice,
    breddPrice,
    transomPrice,
    totalHeightPrice,
    variationPrices,
    taxRate,
    utforandeData,
    calculationType
  })

  const heightCalculator = new HeightCalculator({
    calculationType
  })

  const validator = new FormValidator()

  // CHANGE THIS LINE - Don't use "new" for UIManager
  // Initialize UIManager with the modules
  const uiManager = UIManager.init({
    priceCalculator,
    heightCalculator,
    formValidator: validator // Make sure property name matches what UIManager expects
  })

  // Initialize everything
  uiManager.initialize()

  // Expose the updatePrice function globally for WooCommerce's use
  window.updatePrice = function () {
    uiManager.updatePrice()
  }
})
